module.exports = __webpack_public_path__ + "static/NHaasGroteskTXStd-56It-ab6cfe592438c2fb3263c93aa33f28de.woff";